export default "__VITE_ASSET__cImxxua1__"